module.exports = __webpack_public_path__ + "static/media/covi_phy_two_met.181f2c74.png";